// convention for constants is
// [App_Name]_[Action]
var AssemblyLibraryConstants: IAssemblyLibraryConstants = {
    OPEN_ASSEMBLY_LIBRARY: 'OPEN_ASSEMBLY_LIBRARY',
    CLOSE_ASSEMBLY_LIBRARY: 'CLOSE_ASSEMBLY_LIBRARY',
    ASSEMBLY_LIBRARY_ADD: 'ASSEMBLY_LIBRARY_ADD',
    ASSEMBLY_LIBRARY_UPDATE: 'ASSEMBLY_LIBRARY_UPDATE',
    ASSEMBLY_LIBRARY_DELETE: 'ASSEMBLY_LIBRARY_DELETE',
    ASSEMBLY_LIBRARY_TEMPLATE_HAS_CHANGE: 'ASSEMBLY_LIBRARY_TEMPLATE_HAS_CHANGE',
    ASSEMBLY_LIBRARY_TEMPLATE_ADD: 'ASSEMBLY_LIBRARY_TEMPLATE_ADD',
    ASSEMBLY_LIBRARY_TEMPLATE_UPDATE: 'ASSEMBLY_LIBRARY_TEMPLATE_UPDATE',
    ASSEMBLY_LIBRARY_TEMPLATE_DELETE: 'ASSEMBLY_LIBRARY_TEMPLATE_DELETE',
    ASSEMBLY_TEMPLATES: 'ASSEMBLY_TEMPLATES',
    SET_ASSEMBLY_POSITION: 'SET_ASSEMBLY_POSITION',
    SET_ASSEMBLY_SCALE: 'SET_ASSEMBLY_SCALE',
    ASSEMBLY_LIBRARY_FINISH_EDIT: 'ASSEMBLY_LIBRARY_FINISH_EDIT',
    ASSEMBLY_TEMPLATE_SET_DATA: 'ASSEMBLY_TEMPLATE_SET_DATA',
    ASSEMBLY_TEMPLATE_UPDATE_EDIT: 'ASSEMBLY_TEMPLATE_UPDATE_EDIT',
    ASSEMBLY_LIBRARY_TEMPLATES: 'ASSEMBLY_LIBRARY_TEMPLATES',
    ASSEMBLY_TEMPLATE_INVALID_ADD: 'ASSEMBLY_TEMPLATE_INVALID_ADD',
    ASSEMBLY_LIBRARIES: 'ASSEMBLY_LIBRARIES',
    SET_SELECTED_ASSEMBLY_LIBRARY_ID: 'SET_SELECTED_ASSEMBLY_LIBRARY_ID',
    ASSEMBLY_LIBRARIES_WITH_TEMPLATES: 'ASSEMBLY_LIBRARIES_WITH_TEMPLATES',
} as const;

export default AssemblyLibraryConstants;
